import { Button, EButtonColor } from '@web_opxp/components';
import { useTranslation } from '@web_opxp/features';
import * as React from 'react';
import { connect } from 'react-redux';
import { SKELETON_CLASSNAME } from '../base/constants';
import LevelSection from '../components/LevelSection/LevelSection';
import { DashboardActions } from './slice';

export interface IAssessmentRunningSectionProps {
  cfqRunning: boolean;
  onStartAssessment: (cfq: boolean) => void;
  onSkipAssessment: () => void;
}

export const AssessmentRunningSectionFC: React.FC<IAssessmentRunningSectionProps> = ({
  cfqRunning,
  onStartAssessment,
  onSkipAssessment,
}) => {
  const { t } = useTranslation();
  const [loading, toggleLoading] = React.useState(false);

  const skeletonClass = loading ? SKELETON_CLASSNAME : '';

  const skipAssessmentHandler = () => {
    if (cfqRunning) {
      return;
    }

    toggleLoading(true);
    onSkipAssessment();
  };

  return (
    <LevelSection
      skeletonClass={skeletonClass}
      title={t('Dashboard.TitleAssessment')}
      subtitle={t('Dashboard.AssessmentMessage')}>
      <Button
        disabled={loading}
        color={EButtonColor.white}
        label={t('Dashboard.CTA.ContinueAssessment')}
        onClick={() => onStartAssessment(true)}
        className="assessment-running-button"
      />
      <Button
        disabled={cfqRunning || loading}
        color={EButtonColor.white}
        label={t('Dashboard.CTA.SkipAssessment')}
        onClick={skipAssessmentHandler}
        className="assessment-running-button"
      />
    </LevelSection>
  );
};

export const mapDispatchToProps = {
  onStartAssessment: DashboardActions.startAssessment,
  onSkipAssessment: DashboardActions.skipAssessment,
};

const AssessmentRunningSection = connect(null, mapDispatchToProps)(AssessmentRunningSectionFC);
AssessmentRunningSection.displayName = 'AssessmentRunningSection';

export default AssessmentRunningSection;
